import PickingPanelBlockSelect from '../PickingPanelBlockSelect';
import { PanelConfiguration, PickingPanelBlock } from '@ekkogmbh/apisdk';
import { useCallback, useMemo } from 'react';
import { Stack } from '@mui/system';
import StyledFormAccordion from 'src/Common/Components/Forms/StyledFormAccordion';
import { Box, Chip } from '@mui/material';
import proGloveLogo from 'src/assets/images/ProGloveOrange.png';
interface Props {
  panelConfig: PanelConfiguration;
  onChange: (config: PanelConfiguration) => void;
}

export const PickerProfileGloveForm = ({ panelConfig, onChange }: Props): React.JSX.Element => {
  const setSidePanel = useCallback(
    (configKey: 'gloveBlock1' | 'gloveBlock2' | 'gloveBlock3', block: PickingPanelBlock) => {
      onChange({
        ...panelConfig,
        infos: {
          ...panelConfig.infos,
          [configKey]: block,
        },
      });
    },
    [onChange, panelConfig],
  );

  const blockValue1 = useMemo(
    () => panelConfig?.infos?.gloveBlock1 ?? PickingPanelBlock.COORDINATE,
    [panelConfig?.infos?.gloveBlock1],
  );
  const blockValue2 = useMemo(
    () => panelConfig?.infos?.gloveBlock2 ?? PickingPanelBlock.AMOUNT,
    [panelConfig?.infos?.gloveBlock2],
  );
  const blockValue3 = useMemo(
    () => panelConfig?.infos?.gloveBlock3 ?? PickingPanelBlock.VALUE,
    [panelConfig?.infos?.gloveBlock3],
  );

  return (
    <StyledFormAccordion
      label={'Glove Display'}
      centerLabel={
        <Chip
          variant={'outlined'}
          size={'small'}
          label={<Box component={'img'} src={proGloveLogo} width={64} alignSelf={'center'} sx={{ pt: 0.5 }} />}
        />
      }
    >
      <Stack direction={'column'} spacing={1}>
        <PickingPanelBlockSelect
          label={'Block 1'}
          value={blockValue1}
          onChange={(v) => setSidePanel('gloveBlock1', v)}
        />
        <PickingPanelBlockSelect
          label={'Block 2'}
          value={blockValue2}
          onChange={(v) => setSidePanel('gloveBlock2', v)}
        />
        <PickingPanelBlockSelect
          label={'Block 3'}
          value={blockValue3}
          onChange={(v) => setSidePanel('gloveBlock3', v)}
        />
      </Stack>
    </StyledFormAccordion>
  );
};
